import React, {useEffect, useState} from 'react';
import {useTranslation, Trans} from 'react-i18next';
import {Badge, Modal, ModalHeader, ModalBody} from 'reactstrap';
import axios from '../../../config/axios-interceptor';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Button from '../../../components/Button/Button'
// import {user} from "../../store/actions/auth.actions";
import {user} from '../../../store/actions/auth.actions'
import {useSelector, useDispatch} from 'react-redux';

interface ICalendarModal {
  companyId: number;
  isCalendarOpen: boolean;
  toggleCalendarModal: Function;
}

const CalendarModal = ({ companyId, isCalendarOpen, toggleCalendarModal }: ICalendarModal) => {
  const times = [9, 10, 11, 12, 13, 14, 15, 16, 17, 18]

  // When the currentDate changes on laptop, the date doesnt change on the calendar or this vairaable
  const currentDate = new Date();
  const {t} = useTranslation();
  // const auth_user = useSelector((state) => state.auth.user);
  // const isVisitor = auth_user && auth_user.isVisitor

  const [date, setDate] = useState(new Date());
  // const [date, setDate] = useState(new Date(2020, 12, 1));
  const [availableDatesLoading, setAvailableDatesLoading] = useState(false)
  const [activeDay, setActiveDay] = useState(currentDate.getDate())
  const [allTimes, setAllTimes] = useState<any>([
    [], []
  ])

  useEffect(() => {
    getAppointments(companyId)
  }, [])

  const formatTimesObject = (separatedTimes: any[], day: number) => {
    const arr: any = []

    for(let j = 0; j < times.length; j++){
      let color = 'success';
      let available = true;
      let currentUserSchedule = false;

      for(let i = 0; i < separatedTimes.length; i++) {
        const c: any = new Date(separatedTimes[i].scheduledDate)
        
        // When the date is reserved by someone else
        if(c.getHours() === times[j]){
          color = 'secondary';
          available = false;
          currentUserSchedule = false
        }

        // When the date is reserved by current useer
        if(c.getHours() === times[j] && separatedTimes[i].currentUserSchedule){
          color = 'danger';
          available = false;
          currentUserSchedule = true
        }
      }

      // When the date is expired
      if(day < currentDate.getDate() || times[j] <= currentDate.getHours() && day == currentDate.getDate()) {
        color = 'secondary';
        available = false;
        currentUserSchedule = false
      }

      arr.push({
        time: times[j],
        color: color,
        available: available,
        currentUserSchedule: currentUserSchedule
      })
    }

    console.log('formatTimesObject: ', arr)
    return arr

    // ******************************************
    /*const arr: any = []
    const sortedTimes = [
      ...separatedTimes.sort((a, b) => a - b)
    ]

    console.log('currentDate.getDay(): ', currentDate.getHours())
    times.map(item => {
      let color = 'success';
      let available = true;

      // const findCurrentUserSchedule = sortedTimes.find(a => { return a === item })
      //if(sortedTimes.includes(item)) { //} && findCurrentUserSchedule.currentUserSchedule) { //} item.currentUserSchedule) {
      if(item === currentUserScheduleDate) {
        color = 'danger';
        available = false;
      }
      console.log('asdasdasdsad', item)
      console.log('asdasdasdsad', currentUserScheduleDate)
      // if(day < currentDate.getDate() || (item <= currentDate.getHours() && day == currentDate.getDate())) {
      //   color = 'secondary';
      //   available = false;
      // }

      arr.push({
        time: item,
        color: color,
        available: available
      })
    })

    console.log('formatTimesObject: ', arr)
    return arr*/
  }

  const isTodayDate = (date: number): boolean => {
    const currentDate = new Date();
    
    return currentDate.getDate() === date;
  }

  const separateDates = (fullDates) => {         
    //  dummy data 
    // const fullDates = [
    //   { scheduledDate: "2020-12-01T12:00:00", currentUserSchedule: false },
    //   { scheduledDate: "2020-12-01T13:00:00", currentUserSchedule: false },
    //   { scheduledDate: "2020-12-02T13:00:00", currentUserSchedule: true },
    //   { scheduledDate: "2020-12-01T15:00:00", currentUserSchedule: false },// companyId, uniqueUrl, userId },
    //   { scheduledDate: "2020-12-02T09:00:00", currentUserSchedule: false },
    //   { scheduledDate: "2020-12-02T14:00:00", currentUserSchedule: false },
    //   { scheduledDate: "2020-12-02T12:00:00", currentUserSchedule: false },
    // ]

    const separatedDayOneTimes: any = []
    const separatedDayTwoTimes: any = []

    // arr[date.getDate() - 1].push(date.getHours())
    // [[15,56],[32,56]]

    fullDates.map(item => {
      const fullDate = new Date(item.scheduledDate)

      if(fullDate.getDate() == 1) {
        // separatedDayOneTimes.push(fullDate.getHours())
        separatedDayOneTimes.push(item)
      }

      if(fullDate.getDate() == 2) {
        // separatedDayTwoTimes.push(fullDate.getHours())
        separatedDayTwoTimes.push(item)
      }
    })
    
    const formatedTimes = [
      [...formatTimesObject(separatedDayOneTimes, 1)],
      [...formatTimesObject(separatedDayTwoTimes, 2)]
    ]

    console.log('separateDates: ', formatedTimes)
    setAllTimes(formatedTimes)
  }

  const [currentUserScheduleDate, setCurrentUserScheduleDate] = useState(null)
  const getAppointments = async (companyId) => {
    setAvailableDatesLoading(true)
    
    try {
      // throw Error
      const response = await axios.get(`Calendar/GetAll/${companyId}`);
      
      if (response?.data?.succeeded) {
        console.log('dates: ', response?.data?.data)

        // const currentSchedule = response?.data?.data.find(date => date.currentUserSchedule)
        // const currentScheduleDate: any = new Date(currentSchedule.scheduledDate)
        // setCurrentUserScheduleDate(currentScheduleDate.getHours())
        // console.log('currentSchedulee: ', currentScheduleDate.getHours())

        separateDates(response?.data?.data)
      } else {
        setAllTimes([[], []])
      }
      setAvailableDatesLoading(false)
    } catch (err) {
      setAvailableDatesLoading(false)
    }
  }

  // const getSchedules = async () => {} //Exhibitor

  // const [loadinSetTime, ]
  const makeAppointment = async (time) => {
    const c = new Date(date.setHours(time + 1, 0, 0, 0))
    // console.log('value: ', c.toISOString())

    const body = {
      companyId: companyId,
      scheduledDate: c // '2020-12-01T14:00:00.000Z'
    }

    try {
      const response = await axios.post('Calendar', body);
      // console.log('response: ', response)
      
      if (response.data.succeeded) {
        toggleConfirmScheduleModal()
      } else {
        toggleUserAlreadyScheduled()
      }
    } catch (err) {
    }
  }

  const onCalendarChange = (value) => {
    setActiveDay(value.getDate())
    setDate(value)
  }

  const [selectedTime, setSelectedTime] = useState(0)
  const [displayModalTime, setDisplayModalTime] = useState('')
  const onTimeClick = (timeData) => {
    setSelectedTime(timeData.time)
    setDisplayModalTime(timeData.time > 9 ? timeData.time + ':00' : '0' + timeData.time + ':00')

    if(timeData.currentUserSchedule) {
      // You are scheduled on timeData.time
      togleCurrentScheduleModal()
      return;
    }

    if(timeData.color === 'secondary') {
      // This is not available
      return;
    }

    if(timeData.color === 'success') {
      toggleConfirmScheduleModal()
      return;
    }

    // const backEndDate = new Date('2020-12-01T12:00:00.000Z');
    // console.log('backednDate: ', backEndDate)
  }

  // const [notAvailableModa, ]
  const [confirmScheduleModal, setConfirmScheduleModal] = useState(false)
  const toggleConfirmScheduleModal = () => {
    setConfirmScheduleModal(!confirmScheduleModal);
  }

  const [currentScheduleModal, setCurrentScheduleModal] = useState(false)
  const togleCurrentScheduleModal = () => {
    setCurrentScheduleModal(!currentScheduleModal);
  }

  
  const [userAlreadyScheduled, setUserAlreadyScheduled] = useState(false)
  const toggleUserAlreadyScheduled = () => {
    setUserAlreadyScheduled(!userAlreadyScheduled);
  }

  // if(!isVisitor) {
  //   return (
  //     <Modal isOpen={isCalendarOpen} size="lg" toggle={toggleCalendarModal} contentClassName="border-0"
  //           style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
  //       <ModalHeader toggle={toggleCalendarModal} style={{border: 'none'}}></ModalHeader>
  //       <ModalBody className="px-4 pb-4">
  //         <div className="border border-secondary" style={{width: '350px'}}>
  //           <div className="app-bg-primary text-white text-center py-1">Scheduled Meetings</div>
  //           <div className="px-2 py-3">
  //             {/* <div>26-11-2020 14:00</div> */}
  //           </div>
  //         </div>
  //       </ModalBody>
  //     </Modal>
  //   )
  // }

  return (
    <Modal isOpen={isCalendarOpen}  toggle={toggleCalendarModal} contentClassName="border-0"
          style={{boxShadow: '0px 0px 10px 0px #80C32D', border: '2px solid #80C32D', borderRadius: '6px'}}>
      <ModalHeader toggle={toggleCalendarModal} style={{border: 'none'}}></ModalHeader>
      <ModalBody className="px-4 pb-4">

        <Modal
          isOpen={userAlreadyScheduled}
          toggle={toggleUserAlreadyScheduled}
          // onClosed={closeAll ? toggle : undefined}
          className="mt-5"
        >
          <ModalHeader toggle={toggleUserAlreadyScheduled}>
            {t('calendarScheduled')}
          </ModalHeader>
          <ModalBody className="text-center">
          </ModalBody>
        </Modal>

        <Modal
          isOpen={confirmScheduleModal}
          toggle={toggleConfirmScheduleModal}
          // onClosed={closeAll ? toggle : undefined}
          className="mt-5"
        >
          <ModalHeader toggle={toggleConfirmScheduleModal}>
            {t('scheduleMeeting')} <strong>{displayModalTime} ?</strong>
          </ModalHeader>
          <ModalBody className="text-center">
            <Button type="primary" text={t('calendarYes')} className="mr-4" onClick={() => makeAppointment(selectedTime)} />
            <Button type="primary" text={t('calendarNo')} onClick={() => toggleConfirmScheduleModal()}/>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={currentScheduleModal}
          toggle={togleCurrentScheduleModal}
          // onClosed={closeAll ? toggle : undefined}
          className="mt-5"
        >
          <ModalHeader toggle={togleCurrentScheduleModal}>
             You have scheduled meeting in <strong>{displayModalTime} ?</strong>
             {/* Schedule a meeting on <strong>1 Dec 13:00 ?</strong> */}
          </ModalHeader>
          <ModalBody>
            {/* <Button type="primary" text="Yes" /> */}
            {/* <Button type="primary" text="No" /> */}
          </ModalBody>
        </Modal>

        {!availableDatesLoading &&
        <>
        {/* <Row> */}
          {/* <Col xs={6}> */}
          <div>
            <Calendar
              onChange={onCalendarChange}
              value={date}
              minDate={new Date("2020-12-1")}
              // minDate={new Date("2020-11-27")}
              // minDate={new Date("2020-11-1")}
              maxDate={new Date("2020-12-2")}
            />
            </div>

              <div className="mt-3 border border-secondary" style={{maxWidth: '360px'}}>
                <div className="app-bg-primary text-white text-center py-1">Available Times</div>
                <div className="px-2 py-3">
                  {/* {isTodayDate(1) || isTodayDate(2) && allTimes[activeDay - 1].map((item: any) => { */}
                  {allTimes.length > 1 && allTimes[activeDay - 1] && allTimes[activeDay - 1].map((item: any) => {
                    return (
                      <Badge
                        pill
                        // onClick={() => onTimeClick(item.time)}
                        onClick={() => onTimeClick(item)}
                        style={{
                          cursor: item.color === 'secondary' ? 'not-allowed' : 'pointer'
                        }}
                        color={item.color}
                        className=" text-white py-2 px-3 mr-1 mt-2"
                      >
                        {item.time > 9 ? item.time : '0' + item.time}:00
                      </Badge>
                    )
                  })}
                </div>
              </div>
        </>}
      </ModalBody>
    </Modal>
  )
}

export default CalendarModal;